export const NULL_REPR = {
  __superstoreNull: true
};
export const NAMESPACE_PREFIX = 'hs.superstore';
export const NAMESPACE_SUFFIX = 'default';